module.exports = __webpack_public_path__ + "static/media/Logo_Final-01.adf6ffa7.svg";